import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Typography } from '..';

export const DescriptionBox = ({ title, image, description, redirectTo, className ,buttonText,imageHeight }) => {
    const navigate = useNavigate()
    return (
        <div className={className}>
            <div className='flex flex-col justify-start gap-3'>
                {image && <span className={imageHeight}>
                    <img className='h-full w-full object-contain'  src={image} alt={title + "IMG"} />
                </span>}
                <Typography variant="lg" className="font-semibold" text={title} />
                <Typography variant="sm" text={description} />
                {redirectTo && <div className="flex justify-start">
                    <Button onClick={() => navigate(redirectTo)} variant="tertiary" className="pl-0" text={buttonText} />
                </div>}
            </div>
        </div>
    )
}

DescriptionBox.defaultProps = {
    title: "",
    image: "",
    description: "",
    redirectTo: "",
    className: "p-4",
    buttonText:"View the full list",
    imageHeight:"h-[68px] w-[68px]"
}


